import React, { useState } from "react"
import { useSelector, useDispatch } from "react-redux"
import { Row, Col } from "react-bootstrap"

import Images from "assets/images"
import { SilProjectDevice } from "server/models"
import { EDIT, WARNING } from "const"
import { hasAccess, hasProjectAccess } from "client/utils"
import {
    PRM_SIL_SUBSYSTEM,
    StoreType,
    addModal,
} from "client/store"
import {
    PageForm,
    Logo,
    FormGroup,
    Label,
    Input,
    Textarea,
    Button,
    Link,
    AlertMessage,
} from "client/components"

import SilUpdateSubsystem from "client/pages/sil/update/subsystem"
import Copy from "client/pages/sil/device/copy"

const Form = () => {
    const baseRoute = useSelector((state: StoreType) => state.silDevice.baseSubsystemRoute)
    const subsystem = useSelector((state: StoreType) => state.silDevice.deviceView)
    const project = useSelector((state: StoreType) => state.project.projectView)

    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [showCopy, setShowCopy] = useState(false)

    const editUrl = `${baseRoute}/${EDIT}/${subsystem.id}`

    const editAccess = !project.id
        ? hasAccess(PRM_SIL_SUBSYSTEM, EDIT)
        : hasProjectAccess(PRM_SIL_SUBSYSTEM, EDIT)

    const projectDevice = subsystem as SilProjectDevice
    const isProjectDevice = project.id && projectDevice.deviceId === null

    const subsystemUpdated = lang.subsystemUpdated.split("{0}")

    return (
        <PageForm>
            <Row>
                <Col xs={12} md={3}>
                    <Logo logo={subsystem.logo || Images.silDeviceLogo} />
                </Col>
                <Col xs={12} md={9}>
                    <Row>
                        <Col xs={12}>
                            <FormGroup>
                                <Label>{lang.name}</Label>
                                <Input type="text" value={subsystem.name} readOnly />
                            </FormGroup>
                            <FormGroup>
                                <Label>{lang.manufacturer}</Label>
                                <Input type="text" value={subsystem.manufacturer} readOnly />
                            </FormGroup>
                            <FormGroup>
                                <Label>{lang.description}</Label>
                                <Textarea value={subsystem.description} readOnly />
                            </FormGroup>
                            <FormGroup>
                                <Label>{lang.reference}</Label>
                                <Input type="text" value={subsystem.reference} readOnly />
                            </FormGroup>

                            {
                                (isProjectDevice) && (
                                    <FormGroup>
                                        <Label>{lang.source}</Label>
                                        {
                                            isProjectDevice
                                            && <Input type="text" value={lang.projectDevice} readOnly />
                                        }
                                    </FormGroup>
                                )
                            }

                            <FormGroup>
                                <Label>{lang.status}</Label>
                                <Input type="text" value={lang[subsystem.status]} readOnly />
                            </FormGroup>

                            {
                                subsystem.updated && (
                                    <AlertMessage variant={WARNING}>
                                        <b>{lang.warning}</b>
                                        <div>
                                            {subsystemUpdated[0]}

                                            <Link
                                                href="/#"
                                                onClick={() => {
                                                    dispatch(addModal({
                                                        key: "updateSubsystem",
                                                        content: <SilUpdateSubsystem deviceId={subsystem.id} />,
                                                    }))
                                                }}
                                            >
                                                {lang.here}
                                            </Link>

                                            {subsystemUpdated[1]}
                                        </div>
                                    </AlertMessage>
                                )
                            }
                        </Col>
                        <Col xs={12}>
                            {
                                editAccess && (
                                    <Button
                                        row
                                        onClick={() => dispatch(addModal({ url: editUrl }))}
                                    >
                                        {lang.edit}
                                    </Button>
                                )
                            }
                            <Button row onClick={() => setShowCopy(true)}>{lang.copy}</Button>
                        </Col>
                    </Row>
                </Col>
            </Row>

            <Copy
                device={subsystem}
                show={showCopy}
                onClose={() => setShowCopy(false)}
            />
        </PageForm>
    )
}
export default Form
